import React from "react"
import { Layout, Menu } from "antd"
import { useNavigate } from "react-router-dom"

const { Content, Header } = Layout

export const ScreenLayout = (props) => {
	const navigate = useNavigate()
	const handleLogout = () => navigate("/login")
    const handleProductNav = () => navigate("/products")
	const handleOrderNav = () => navigate("/dashboard")
	return (
		<Layout style={{ height: "100vh" }}>
			<Header style={{ paddingRight: 10, paddingLeft: 20 }}>
				
				<Menu onClick={handleLogout} theme="dark" mode="horizontal" style={{ float: "right", width: 100 }}>
					<Menu.Item key="logout">Logout</Menu.Item>
				</Menu>
				<Menu onClick={handleOrderNav} theme="dark" mode="horizontal" style={{ float: "right", width: 100 }}>
					<Menu.Item key="orders">Orders</Menu.Item>
				</Menu>
				<Menu onClick={handleProductNav} theme="dark" mode="horizontal" style={{ float: "right", width: 100 }}>
					<Menu.Item key="products">Products</Menu.Item>
				</Menu>
			</Header>
			<Content>{props.children}</Content>
		</Layout>
	)
}
